import {formatToCurrencyType} from "helper/common";
import moment from "moment";
import React from "react";
import {FORMAT_TIME} from "types/enums";

const getTodayString = () => {
  // const today = moment().format();
  const day = moment().format("DD");
  const month = moment().format("MM");
  const year = moment().format("YYYY");
  const time = moment().format("HH:mm");
  return `${time} Ngày ${day} tháng ${month} năm ${year}`;
};

const columns: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    fixed: "left",
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "noiDung",
    key: "noiDung",
    align: "left",
    width: "35%",
  },
  // {
  //   title: "Đơn vị",
  //   dataIndex: "donVi",
  //   key: "donVi",
  //   align: 'center'
  // },
  {
    title: "SL",
    dataIndex: "soLuong",
    key: "soLuong",
    align: "right",
  },
  {
    title: "Đơn giá BV",
    dataIndex: "donGiaBV",
    key: "donGiaBV",
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Số tiền miễn giảm",
    dataIndex: "soTienMienGiam",
    key: "soTienMienGiam",
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BH chi trả",
    dataIndex: "bhChiTra",
    key: "bhChiTra",
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BN cùng chi trả",
    dataIndex: "bnCungChiTra",
    key: "bnCungChiTra",
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Lý do miễn giảm",
    dataIndex: "lyDoMienGiam",
    key: "lyDoMienGiam",
    align: "right",
  },
  {
    title: "Thành tiền",
    dataIndex: "thanhTien",
    key: "thanhTien",
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Trạng thái TT",
    dataIndex: "trangThaiThanhToan",
    key: "trangThaiThanhToan",
    align: "left",
    render: trangThaiThanhToan => {
      if (trangThaiThanhToan == 0)
        return (
          <div className="pay-status">
            {/* <div className="icon-success">
              <UnSuccessSVG />
            </div> */}
            <div>Chưa thanh toán</div>
          </div>
        );
      if (trangThaiThanhToan == 1)
        return (
          <div className="pay-status">
            {/* <div className="icon-success">
              <SuccessStatusSVG className="pay-tab-success" />
            </div> */}
            <div>Đã thanh toán</div>
          </div>
        );
      if (trangThaiThanhToan == 2)
        return (
          <div className="pay-status">
            {/* <div className="icon-success">
              <UnSuccessSVG className="cancel-icon" />
            </div> */}
            <div>Đã tạm ứng</div>
          </div>
        );
      // if (status == 3)
      //   return (
      //     <div className="pay-status">
      //       <div className="icon-success">
      //         <SuccessStatusSVG className="pay-tab-success" />
      //       </div>
      //       <div style={{ color: "#00B335" }}>Đề nghị hoàn phí</div>
      //     </div>
      //   );
      if (trangThaiThanhToan == 3)
        return (
          <div className="pay-status">
            {/* <div className="icon-success">
              <SuccessStatusSVG className="refunds-success" />
            </div> */}
            <div>Đã hoàn phí</div>
          </div>
        );
    },
  },
];

export {columns, getTodayString};
